import { documentKindFromName, fileExtension, type DocumentKind } from '@/utils/documentKind'

/**
 * The badge colour groups formats by what they are, so a row of attachments
 * reads at a glance: documents red, anything tabular green, structured text
 * violet, pictures blue. A format with no group is grey and says FILE, which
 * is the honest answer and the one the viewer gives it too.
 */
const BADGE: Record<DocumentKind, string> = {
  pdf: 'bg-red-500',
  spreadsheet: 'bg-emerald-600',
  csv: 'bg-emerald-600',
  xml: 'bg-violet-500',
  image: 'bg-sky-500',
  text: 'bg-gray-400',
  other: 'bg-gray-400',
}

/** An extension long enough to crowd the filename is not worth showing in full. */
function badgeLabel(name: string): string {
  const extension = fileExtension(name)
  if (!extension) return 'FILE'

  return extension.toUpperCase()
}

function withoutExtension(name: string): string {
  const extension = fileExtension(name)
  if (!extension) return name

  return name.slice(0, -(extension.length + 1))
}

/** One attachment in an inbox row: what kind of file it is, and what it is called. */
export function AttachmentChip({ name }: { name: string }) {
  const kind = documentKindFromName(name)

  return (
    <span
      className="inline-flex shrink-0 items-center gap-1 rounded-md border border-gray-200 bg-white px-2 py-0.5 text-[11px] text-gray-600"
      title={name}
    >
      <span className={`rounded-sm ${BADGE[kind]} px-0.5 py-px text-[8px] font-bold leading-none text-white`}>
        {badgeLabel(name)}
      </span>
      <span className="max-w-[72px] truncate">{withoutExtension(name)}</span>
    </span>
  )
}
